import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full py-12 px-4" data-id="element-117">
      <div className="max-w-3xl mx-auto" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-119">
          <h2 className="font-handwriting text-4xl md:text-5xl lg:text-6xl text-forest font-bold mb-6 leading-tight" data-id="element-120">
            "Finn verdaute kaum noch – <br className="hidden md:block" data-id="element-121" />
            sein Darm war wie eingeschlafen"
          </h2>
          <p className="font-serif text-lg md:text-xl text-brown/90 max-w-2xl mx-auto leading-relaxed" data-id="element-122">
            Wie ich die träge Verdauung meines Hundes auf natürlichem Weg wieder
            in Schwung brachte.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white rotate-1" data-id="element-123">
          <img src="https://images.unsplash.com/photo-1552053831-71594a27632d?q=80&w=1000&auto=format&fit=crop" alt="Ein süßer Cocker Spaniel liegt müde und gemütlich auf einer Decke" className="w-full h-[400px] object-cover" data-id="element-124" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" data-id="element-125"></div>
        </motion.div>
      </div>
    </section>;
}